import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/esm/Button";
import { useNavigate } from "react-router-dom";
import { makeGetRequest } from "../../utils/api";
import { urls } from "../../utils/urls";
import SimpleResourceItems from "../geriactive/resources/SimpleResourceItems";
import NoResourceMessage from "../geriactive/resources/NoResourceMessage";
import PLM_WEEKS from "./plmWeeks";
import { overlayButtonStyle } from "../../utils/layout";

function PlmWeek(props) {
  const [resourceItems, setResourceItems] = useState([]);
  const [dataPulled, setDataPulled] = useState(false);
  const navigate = useNavigate();
  const weekConfig = PLM_WEEKS.find((item) => item.week === props.week);
  // Lighter than the 5px edge on the homepage tiles: a list of these reads as
  // a stack of bars at 5px.
  const itemBorder = "3px solid " + weekConfig.borderColor;

  const handleResourceData = async () => {
    const response = await makeGetRequest(
      urls.resources + "?active=True&resource_type=" + weekConfig.resourceType,
      "",
      true
    );
    setResourceItems(Array.isArray(response?.data) ? response.data : []);
    setDataPulled(true);
  };

  useEffect(() => {
    handleResourceData();
  }, []);

  return (
    <>
      <Button
        style={{
          ...overlayButtonStyle(0),
          backgroundColor: weekConfig.color,
          color: weekConfig.fontColor,
          border: itemBorder,
        }}
        onClick={() => navigate("/home")}
      >
        Back Home
      </Button>
      {resourceItems.length === 0 && dataPulled === true ? (
        <NoResourceMessage />
      ) : (
        <SimpleResourceItems
          items={resourceItems}
          backgroundC={weekConfig.color}
          fontColor={weekConfig.fontColor}
          borderC={itemBorder}
          overlayRow={1}
        />
      )}
    </>
  );
}

export default PlmWeek;
